import { render, staticRenderFns } from "./VerticalContent.vue?vue&type=template&id=66305a52&"
import script from "./VerticalContent.vue?vue&type=script&lang=js&"
export * from "./VerticalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports